import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const ScrollButton: React.FC = () => {
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setHasScrolled(scrollTop > 100); // Show button after scrolling 100px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToNext = () => {
    const nextSection = document.getElementById('my-vision');
    nextSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AnimatePresence>
      {hasScrolled ? (
        // Back to top button
        <motion.div
          key="back-to-top"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-8 right-4 md:left-1/2 md:-translate-x-1/2 md:right-auto z-50"
        >
          <button
            onClick={scrollToTop}
            className="flex flex-col items-center text-gray-600 hover:text-edata-blue transition-colors duration-300 bg-white/80 backdrop-blur-sm rounded-full p-4 shadow-lg hover:shadow-xl"
          >
            <span className="text-sm mb-2 hidden md:block">Back to top</span>
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <ChevronDown size={24} className="rotate-180" />
            </motion.div>
          </button>
        </motion.div>
      ) : (
        // Scroll to explore message
        <motion.div
          key="scroll-explore"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-8 right-4 md:left-1/2 md:-translate-x-1/2 md:right-auto z-50"
        >
          <button
            onClick={scrollToNext}
            className="flex flex-col items-center text-gray-600 hover:text-edata-blue transition-colors duration-300 bg-white/80 backdrop-blur-sm rounded-full p-4 shadow-lg hover:shadow-xl"
          >
            <span className="text-sm mb-2 hidden md:block">Scroll to explore</span>
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <ChevronDown size={24} />
            </motion.div>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ScrollButton; 